import React, { useEffect, useState, useContext } from "react";
import Row from "../Row";
import Column from "../Column";
import jobContext from "src/context/jobContext";
import { useLocation } from "react-router-dom";


const Table14 = ({ argonomi, setArgonomi, reload }) => {

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const jobId = params.get("id");
  const { setGreadingScore } = useContext(jobContext)

  const [data, setData] = useState([])
  useEffect(() => {
    const items = JSON.parse(localStorage?.data)?.[jobId]?.argonomi;
    if (items) {
      const masouliat = items[Object.keys(items)[0]];
      const masouliatData = [
        { name: "سطح یک", score: 6, isSelected: masouliat.value == 0 },
        { name: "سطح دو", score: 12, isSelected: masouliat.value == 1 },
        { name: "سطح سه", score: 18, isSelected: masouliat.value == 2 },
        { name: "سطح چهار", score: 24, isSelected: masouliat.value == 3 },
        { name: "سطح پنج", score: 30, isSelected: masouliat.value == 4 },

      ]

      setData(masouliatData)

      const selectedItem = masouliatData.find((i) => i.isSelected)?.score
      setArgonomi(selectedItem)
      setGreadingScore((prev) => ({ ...prev, "argonomi": selectedItem }))
    }
  }, [reload])
  return (
    <div>
      <Row type={1}>
        <Column>سطح 1</Column>
        <Column>سطح 2</Column>
        <Column>سطح 3</Column>
        <Column>سطح 4</Column>
        <Column>سطح 5</Column>
      </Row>
      <Row type={2}>
        <Column paddingY={30}>
          علی رغم رعایت اصول
          ایمنی و مقررات
          بهداشتی، ممکن است
          موجب جراحات سطحی
          برای دیگران شوند
        </Column>
        <Column paddingY={30}>
          علی رغم رعایت اصول
          ایمنی و مقررات
          بهداشتی، ممکن است
          موجب جراحات عمیق
          برای دیگران شوند
        </Column>
        <Column paddingY={30}>
          علی رغم رعایت
          اصول ایمنی و
          مقررات بهداشتی،
          ممکن است موجب
          نقص عضو جزئی
          برای دیگران شوند
        </Column>
        <Column paddingY={30}>
          علی رغم رعایت
          اصول ایمنی و
          مقررات بهداشتی،
          ممکن است موجب
          نقص عضو کلی برای
          دیگران شوند
        </Column>
        <Column paddingY={30}>
          علی رغم رعایت اصول
          ایمنی و مقررات
          بهداشتی، ممکن است
          موجب از کار افتادگی و
          مرگ و میر دیگران شوند
        </Column>
      </Row>
      <Row>
        <Column isActive={argonomi == 6}>6</Column>
        <Column isActive={argonomi == 12}>12</Column>
        <Column isActive={argonomi == 18}>18</Column>
        <Column isActive={argonomi == 24}>24</Column>
        <Column isActive={argonomi == 30}>30</Column>
      </Row>
    </div>
  );
};

export default Table14;
